// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false
import 'expose-loader?$!expose-loader?jQuery!jquery'


router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '솔닥웹'

  const description = to.meta.description || '솔닥웹'
  let tag = document.querySelector('meta[name="description"]')

  let tag2 = document.querySelector('meta[property="og:description"]')


  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', 'description')
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', description)


  if (!tag2) {
    tag2 = document.createElement('meta')
    tag2.setAttribute('property', 'og:description')
    document.head.appendChild(tag2)
  }
  tag2.setAttribute('content', description)


  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js